// extracted by mini-css-extract-plugin
module.exports = {"postCategory":"Category_postCategory__xYwEt"};